module.exports = __webpack_public_path__ + "img/image3.47b45faf.png";